import { createContext, useState } from 'react'

import React from 'react'


export const defaultLang = createContext('Ita')

export default function LanguageContext({children}) {
const [lang, setLang] = useState('Ita')


  return (
    <defaultLang.Provider value={{lang : lang, setLang : setLang}}>
        {children}
        </defaultLang.Provider>
  )
}
